import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import {Amplify} from '@aws-amplify/core';
import {Auth} from '@aws-amplify/auth';
import awsconfig from '../src/aws-exports';
import "@aws-amplify/ui-vue/styles.css";
import { VueSpinnersPlugin } from 'vue3-spinners';
import axios from 'axios';
import { Capacitor } from '@capacitor/core';

loadFonts()

// Configure Amplify with Capacitor compatibility
const amplifyConfig = {
  ...awsconfig,
  // Fix API configuration - aws-exports uses 'aws_cloud_logic_custom' not 'API.endpoints'
  API: {
    endpoints: awsconfig.aws_cloud_logic_custom?.map(endpoint => ({
      ...endpoint,
      custom_header: async () => {
        return {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        };
      }
    }))
  }
};

console.log('[Amplify Config] Configuring with endpoints:', amplifyConfig.API.endpoints);

Amplify.configure(amplifyConfig);
Auth.configure(amplifyConfig)

// Configure axios defaults for all requests
axios.defaults.timeout = 30000;
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Add request interceptor
axios.interceptors.request.use(
  (config) => {
    // Log requests in development/native mode
    if (Capacitor.isNativePlatform() || process.env.NODE_ENV === 'development') {
      console.log('Global Axios Request:', {
        url: config.url,
        method: config.method,
        headers: config.headers
      });
    }
    
    // Ensure proper headers for CORS in native apps
    if (Capacitor.isNativePlatform()) {
      config.headers['Accept'] = 'application/json';
      delete config.headers['X-Requested-With'];
    }
    
    return config;
  },
  (error) => {
    console.error('Global request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Enhanced error logging
    if (error.response) {
      console.error('Global API Error Response:', {
        url: error.config?.url,
        status: error.response.status,
        data: error.response.data
      });
    } else if (error.request) {
      console.error('Global API No Response:', {
        url: error.config?.url,
        message: error.message
      });
    }
    
    return Promise.reject(error);
  }
);


const app = createApp(App);

// Make Capacitor available globally in Vue components
app.config.globalProperties.$capacitor = Capacitor;

app
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueSpinnersPlugin)
  .mount('#app')
